module.exports = __webpack_public_path__ + "static/media/intro.a13b89f5.mp3";